import React, { useCallback, useEffect, useRef, useState } from 'react';
import Chart from 'react-apexcharts';

import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import * as Yup from 'yup';

import { ReactComponent as SearchIcon } from '../../../../../assets/icons/ubr_search.svg';
import { Button, Select } from '../../../../../components';
import { defaultOptions_PrincipaisErros } from '../../../../../mocks/data';
import api from '../../../../../services/api';
import getValidationErrors from '../../../../../utils/getValidationErrors';
import { layout, periodo, quantidade } from '../dataFilter';
import { ActionsForm, ChartCard, ContainerFilter } from '../styles';

interface GraficosProps {
  periodo?: number;
  quantidade?: number;
  tipoValidacao?: string;
  descricao?: string;
  categorias?: string;
}

interface PrincipaisCriticasSearch {
  periodo?: number;
  quantidade?: number;
  tipoValidacao?: string;
}

const GraficoPrincipaisErros: React.FC = () => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [dataPrincipaisErros, setDataPrincipaisErros] = useState<
    GraficosProps[]
  >([]);
  const [seriesPrincipaisErros, setSeriesPrincipaisErros] = useState<number[]>(
    [],
  );
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [labelsPrincipaisErros, setLabelsPrincipaisErros] = useState<string[]>(
    [],
  );
  const [
    graphConfigPrincipaisErros,
    setgraphConfigPrincipaisErros,
  ] = useState<any>(defaultOptions_PrincipaisErros);
  const formRef = useRef<FormHandles | null>(null);

  let selectedQuantidade = useRef<any>();
  let selectedPeriodo = useRef<any>();
  let selectedLayout = useRef<any>();
  const fetchDataPrincipaisErros = useCallback(async () => {
    try {
      const response = await api.get(
        'convenio/grafico/principaisCriticas?quantidade=5&periodo=15',
      );
      const dataPrincipaisErros = response.data;
      const labels = dataPrincipaisErros.map((item: any) => item.descricao);
      const series = dataPrincipaisErros.map((item: any) => item.quantidade);
      setLabelsPrincipaisErros(labels);
      setSeriesPrincipaisErros(series);
      const Config_PrincipaisErros = {
        ...graphConfigPrincipaisErros,
        theme: {
          monochrome: {
            enabled: true,
            color: '#166649',
          },
        },
        stroke: {
          show: true,
          width: 2,
          colors: ['#166649'],
          curve: 'smooth',
          lineCap: 'butt',
          dashArray: 0,
        },
        fill: {
          type: 'gradient',
          gradient: {
            shade: 'light',
            type: 'vertical',
            shadeIntensity: 0.25,
            opacityFrom: 0.7,
            opacityTo: 1,
            stops: [0, 90, 100],
          },
        },
        labels,
        legend: {
          position: 'bottom',
        },
      };
      setgraphConfigPrincipaisErros(Config_PrincipaisErros);

      setDataPrincipaisErros(dataPrincipaisErros);
    } catch (e) {
      console.error(e);
    }
  }, []);

  useEffect(() => {
    fetchDataPrincipaisErros();
  }, [fetchDataPrincipaisErros]);

  //Filtro Principais Criticas
  const handleFilterPrincipaisErros = async (
    data: PrincipaisCriticasSearch,
  ) => {
    data.quantidade = selectedQuantidade.current;
    data.periodo = selectedPeriodo.current;
    data.tipoValidacao = selectedLayout.current;
    try {
      formRef.current?.setErrors({});

      const schema = Yup.object().shape({
        periodo: Yup.string().required('Este campo é obrigatório!'),
        quantidade: Yup.string().required('Este campo é obrigatório!'),
      });
      await schema.validate(data, {
        abortEarly: false,
      });

      let URL = `convenio/grafico/principaisCriticas?quantidade=${data.quantidade}&periodo=${data.periodo}`;
      URL += data.tipoValidacao ? `&tipoValidacao=${data.tipoValidacao}` : '';
      const response = await api.get(URL);

      const dataPrincipaisErros = response.data;
      const labels = dataPrincipaisErros.map((item: any) => item.descricao);
      const series = dataPrincipaisErros.map((item: any) => item.quantidade);
      setLabelsPrincipaisErros(labels);
      setSeriesPrincipaisErros(series);
      const Config_PrincipaisErros = {
        ...graphConfigPrincipaisErros,
        labels,
      };

      setgraphConfigPrincipaisErros(Config_PrincipaisErros);

      setDataPrincipaisErros(dataPrincipaisErros);
    } catch (err) {
      if (err instanceof Yup.ValidationError) {
        const errorMessages = getValidationErrors(err);
        formRef.current?.setErrors(errorMessages);
        return;
      }
    }
  };

  return (
    <>
      <ChartCard>
        <h2>Principais Erros</h2>
        <Form
          className="form-container"
          ref={formRef}
          onSubmit={handleFilterPrincipaisErros}
        >
          <ContainerFilter>
          <div className="field-select" style={{ marginLeft: '1rem' }}>
              <Select
                name={'layout'}
                isMulti={false}
                options={layout}
                onChange={option => (selectedLayout.current = option.value)}
                placeholder=" "
                label="Layout"
                width={'100px'}
              />
            </div>
            <div className="field-select" style={{ marginLeft: '1rem' }}>
              <Select
                name={'periodo'}
                isMulti={false}
                options={periodo}
                onChange={option => (selectedPeriodo.current = option.value)}
                placeholder=" "
                label="Periodo"
                width={'100px'}
              />
            </div>

            <div className="field-select">
              <Select
                name={'quantidade'}
                isMulti={false}
                options={quantidade}
                onChange={option => (selectedQuantidade.current = option.value)}
                placeholder=" "
                label="Quantidade"
                width={'100px'}
              />
            </div>

            <ActionsForm>
              <Button
                variant="solid-icon"
                type={'submit'}
                style={{ marginRight: '1rem' }}
                tooltipText={'Pesquisar'}
              >
                <SearchIcon style={{ width: '26px' }} />
              </Button>
            </ActionsForm>
          </ContainerFilter>
        </Form>
        <div className="chart-legend">
          <Chart
            options={graphConfigPrincipaisErros}
            series={seriesPrincipaisErros}
            type="pie"
            width={500}
          />
        </div>
      </ChartCard>
    </>
  );
};

export default GraficoPrincipaisErros;
